import { render, staticRenderFns } from "./strengthScore.vue?vue&type=template&id=6b19343a&scoped=true&"
import script from "./strengthScore.vue?vue&type=script&lang=js&"
export * from "./strengthScore.vue?vue&type=script&lang=js&"
import style0 from "./strengthScore.vue?vue&type=style&index=0&id=6b19343a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19343a",
  null
  
)

export default component.exports